/*=========================================================================================
  File Name: module-usertax-getters.js
  Description: UserTax Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	regisHistory: function(state) {
		return state.regisHistory;
	},
	Total: function(state) {
		return state.Total;
	},
	taxPayRegisInfo: function(state) {
		return state.taxPayRegisInfo;
	},
	taxDecRegisInfo: function(state) {
		return state.taxDecRegisInfo;
	},
	bankListByTaxCode: function(state) {
		return state.bankListByTaxCode;
	},
	listDecTaxContactAdditional: function(state) {
		return state.listDecTaxContactAdditional;
	},
	listPayTaxContactAdditional: function(state) {
		return state.listPayTaxContactAdditional;
	},
	isWaitingProcessDec: function(state) {
		return state.isWaitingProcessDec;
	},
	isWaitingProcessPay: function(state) {
		return state.isWaitingProcessPay;
	},
	isRegisServiceDeclareTax: function(state) {
		return state.isRegisServiceDeclareTax;
	},
	isRegisServicePayTax: function(state) {
		return state.isRegisServicePayTax;
	},
	DecRegis: function(state) {
		return state.DecRegis;
	},
	PayRegis: function(state) {
		return state.PayRegis;
	},
	isDecTaxCheckCompleted: function(state) {
		return state.isDecTaxCheckCompleted;
	},
	isPayTaxCheckCompleted: function(state) {
		return state.isPayTaxCheckCompleted;
	}
};
